import { SyntheticEvent, useCallback, useState } from 'react'

export type ISwitcher = ReturnType<typeof useSwitcher>

export const useSwitcher = (value: boolean | (() => boolean)) => {
  const [active, setActive] = useState(value)

  const handleOpen = useCallback(
    (e?: SyntheticEvent) => {
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }
      setActive(true)
    },
    [setActive]
  )

  const handleClose = useCallback(
    (e?: SyntheticEvent) => {
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }
      setActive(false)
    },
    [setActive]
  )

  const handleToggle = useCallback(
    (e?: SyntheticEvent) => {
      if (e && e.stopPropagation) {
        e.stopPropagation()
      }
      setActive((state) => !state)
    },
    [setActive]
  )

  return {
    active,
    handleClose,
    handleOpen,
    handleToggle
  }
}
